import { t } from 'i18next';
import React, { FC, MouseEventHandler } from 'react';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import { logout } from '../../lib/auth';
import { NavbarItemInterface } from '../Navbar/NavbarItem';

import Header from './Header';

const HeaderMain: FC = () => {
  const { actorType, admin, organizer } = useCurrentActor();
  const signedIn = actorType !== 'GuestUser';
  const adminAccess = organizer || admin;

  const handleLogOut: MouseEventHandler = (e) => {
    e.preventDefault();

    logout();
  };

  const primaryItems: NavbarItemInterface[] = [
    {
      icon: 'home',
      label: t('menu.main.home'),
      path: '/',
    },
    {
      icon: 'calendar-check-o',
      label: t('menu.main.events'),
      path: signedIn ? '/static/events' : '/static/start#event',
    },
    {
      icon: 'rocket',
      label: t('menu.main.impact'),
      path: '/static/impact',
    },
  ];

  const secondaryItems = [
    {
      label: t('menu.main.help'),
      path: '/pages/help',
    },
    adminAccess && {
      label: t('menu.main.goToAdmin'),
      path: GLOBALS.adminRoot,
      onClick: () => window.open(GLOBALS.adminRoot),
    },
    signedIn && {
      label: t('menu.main.signOut'),
      onClick: handleLogOut,
      path: '/u/sign_out',
    },
  ].filter(Boolean) as NavbarItemInterface[];

  return <Header primaryItems={primaryItems} secondaryItems={secondaryItems} />;
};

export default HeaderMain;
